import React from 'react';
import './Footer.css';
import Menu from './Images/Menu.svg';
import logo from './Images/logo.png';
function Footer({ SetPopUp, popUp, form, SetForm, description }) {
  const handleClick = () => {
    SetPopUp(!popUp);
  };

  return (
    <>

<div className='menu'>
      <img className="imgz" onClick={handleClick} src={Menu} alt="menu" />
    </div>
        {/* <div className='logo'>
    
    <img className="logoz" style={{width:"100px"}} src="https://i.ibb.co/k8TVQQ2/LOGO-2-2.png" alt="logo" />
 
  </div> */}
        <div className="Footer-Container">
      {description && (
        <div className="text-area">
          <div className="text">{description}</div>
        </div>
      )}
    </div>

    </>
  );
}

export default Footer;
